import { render } from "./PriceUser.vue?vue&type=template&id=3a0de252&scoped=true"
import script from "./PriceUser.vue?vue&type=script&lang=js"
export * from "./PriceUser.vue?vue&type=script&lang=js"

import "./PriceUser.vue?vue&type=style&index=0&id=3a0de252&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0de252"]])

export default __exports__